import "es6-promise/auto";
import store from "../../store";
import { ApplicationInitializer, VueLoader } from "../base";
import { DomainRegistry } from "./domain";
import { RouterFactory } from "./routing";

// 設定等必要な初期化を行ってからVue開始.
ApplicationInitializer.initialize(store, DomainRegistry.instance)
.then(() => {
  VueLoader.load(store, RouterFactory.create());
});
